const ITEMS = [
  "REAL ESTATE ADVISORY",
  "CONSULENZA DI PARTE",
  "CASE NON IN VETRINA",
  "VERIFICHE DOCUMENTATE",
  "IMPRESA PARTNER EDILIZIA CANNINO",
  "PORTALE DEDICATO",
  "PROFESSIONISTI SELEZIONATI",
];

const Row = ({ hidden = false }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden || undefined}>
    {ITEMS.map((item, i) => (
      <span key={i} className="flex items-center">
        <span className="px-8 font-mono text-[11px] uppercase tracking-[0.3em] text-[#a08b5f] md:px-12">{item}</span>
        <span className="h-1 w-1 rotate-45 bg-gold/60" />
      </span>
    ))}
  </div>
);

export default function EditorialMarquee() {
  return (
    <div className="marquee" data-testid="editorial-marquee">
      <div className="marquee-track">
        <Row />
        <Row hidden />
      </div>
    </div>
  );
}
